// removed by extract-text-webpack-plugin
module.exports = {"container":"container___VJiRn","catHeader":"catHeader___hMTDM","viewAll":"viewAll___r1xKc","tagContainer":"tagContainer___1-lPq","tagLabel":"tagLabel___134wO","tagDropdown":"tagDropdown___35jDI","tagDropdownLong":"tagDropdownLong___2H4vD","displayType":"displayType___2iA7t","alphabetContainer":"alphabetContainer___2zVYI","singeAlphabet":"singeAlphabet___2e6iY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentDisplay/ContentDisplay.module.css
// module id = 320
// module chunks = 0